import { Injectable } from '@angular/core';
import {ToastController, LoadingController} from 'ionic-angular';
import { Messages } from '../providers/data';

@Injectable()
export class MsgManager {

	loading:any = null;

	constructor(private toastCtrl:ToastController,
		private loadingCtrl:LoadingController){

	}

	getAuthMsg(){
		return Messages.AuthMsg;
	}

	getLoginSuccessMsg(){
		return Messages.LoginSuccessMsg;
	}

	getLogingErrorMsg(){
		return Messages.LogingErrorMsg;
	}

	getInventoryupdateMsg(){
		return Messages.inventoryUpdated;
	}

	getLoginSuccessCustomerMsg(){
		return Messages.LoginSuccessCustomerMsg;
	}

	getOrderPlaceSuccessMsg(){
		return Messages.OrderPlaceSuccessMsg;
	}

	getOrderPlaceFailMsg(){
		return Messages.OrderPlaceFailMsg;
	}

	getPasswordRestRequestSuccessMsg(){
		return Messages.PasswordRestRequestSuccessMsg;
	}

	getPasswordChangeSuccessMsg(){
		return Messages.PasswordChangeSuccessMsg;
	}

	getLoadingMsg(){
		return Messages.LoadingMsg;
	}

	getWentWrongMsg(){
		return Messages.WentWrongMsg;
	}

	getCannotModifySelf(){
		return Messages.cannotModifySelf;
	}

	getIntelliRepUserDeleteConfirm(){
		return Messages.intelliRepUserDeleteConfirm;
	}
	getSessionOutMsg(){
		return Messages.sessionOutMsg;
	}

	async toastMsg(msg){
	let toast = await this.toastCtrl.create({
		message: msg,
				duration: 3000,
				position: 'middle'
			});
			
      toast.present();
	}

	startLoading(){
		this.loading = this.loadingCtrl.create({
		    content: 'Please wait...'
		  });

		  this.loading.present();
	}
	stopLoading(){
		if (this.loading != null) {
			this.loading.dismiss();
		}

	}
	

}


// WEBPACK FOOTER //
// ./src/providers/msg-manager.ts